.content {
  display: flex;
  flex-direction: column;
  align-items: center;

  @media only screen and (max-width: 427px) {
    & > div > div:first-child {
      text-align: center;
    }
  }
}

.description {
  @media only screen and (max-width: 427px) {
    text-align: center;
  }
}
